// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import OptionsSidebar from './OptionsSidebar';

class BrandAndModels extends Component {
  constructor(props) {
    super(props);

    this.state = {
      brandsOptions: [],
      modelsOptions: [],
      filterLoaded: false,
      brandsSideBarOpened: false,
      modelsSideBarOpened: false,
    };

    this.watchFilterOptionsStore = this.watchFilterOptionsStore.bind(this);
    this.filterModelsOptions = this.filterModelsOptions.bind(this);
    this.handleToggleSidebar = this.handleToggleSidebar.bind(this);
    this.handleUpdateBrandField = this.handleUpdateBrandField.bind(this);
    this.handleUpdateField = this.handleUpdateField.bind(this);
  }

  componentDidMount() {
    this.watchFilterOptionsStore();
  }

  watchFilterOptionsStore() {
    window.store.FilterOptions.watch(state => {
      const { options, loading } = state;

      this.setState({
        brandsOptions: options.brands || [],
        modelsOptions: options.models || [],
        filterLoaded: !loading,
      });
    });
  }

  filterModelsOptions() {
    const brands = this.props.activeBrands;
    const { modelsOptions } = this.state;

    if (!brands || !modelsOptions) return [];

    const availableModels = brands.flatMap(
      activeBrand => modelsOptions[activeBrand] || [],
    );

    const uniqueAvailableModels = Array.from(
      new Set(availableModels.map(model => model.title.toUpperCase())),
    );

    return uniqueAvailableModels.map(title => ({
      title,
      value: title,
    }));
  }

  handleBrandsOpenSidebar() {
    this.setState({
      brandsSideBarOpened: true,
    });
  }

  handleToggleSidebar(sidebarKey) {
    return event => {
      const oldState = this.state;
      const currentSidebarState = oldState[sidebarKey];

      if (currentSidebarState) event.stopPropagation();

      this.setState({
        [sidebarKey]: !currentSidebarState,
      });
    };
  }

  handleModelsOpenSidebar() {
    this.setState({
      modelsSideBarOpened: true,
    });
  }

  handleModelsBackSidebar(event) {
    event.stopPropagation();

    this.setState({
      modelsSideBarOpened: false,
    });
  }

  handleUpdateBrandField(brandValue) {
    this.props.handleUpdateFilter('brands', brandValue);
  }

  handleUpdateField(filterKey) {
    return event => {
      const value = event.target.value;
      this.props.handleUpdateFilter(filterKey, value);
    };
  }

  render() {
    const { brandsOptions, brandsSideBarOpened, modelsSideBarOpened } =
      this.state;

    const { activeBrands, activeModels } = this.props;

    return (
      <div className="advanced-filter__brands-and-models brands-and-models">
        <h4 className="advanced-filter__section-title">Marcas e Modelos</h4>
        <ul className="brands-and-models__brands-items">
          {brandsOptions.length > 0 &&
            brandsOptions.slice(0, 9).map(brand => (
              <li
                className="brands-and-models__brand-item"
                data-active={activeBrands.includes(brand.title)}
                onChange={() => this.handleUpdateBrandField(brand.title)}
              >
                <label className="brands-and-models__brand-label-wrapper">
                  <input
                    className="brands-and-models__brand-checkbox"
                    type="checkbox"
                    value={brand.title}
                  />
                  <img
                    className="brands-and-models__brand-image"
                    src={brand.logo || 'https://placehold.co/32x32'}
                    alt={`Logo da ${brand.title}`}
                  />
                  <p className="brands-and-models__brand-label">
                    {brand.title}
                  </p>
                </label>
              </li>
            ))}
        </ul>

        {brandsOptions.length > 0 && (
          <button
            class="btn button button--outline brands-and-models__brand-see-all"
            onClick={this.handleToggleSidebar('brandsSideBarOpened')}
          >
            Ver todas
          </button>
        )}

        <button
          class="btn button button--outline brands-and-models__models-button"
          onClick={this.handleToggleSidebar('modelsSideBarOpened')}
          data-disabled={activeBrands.length === 0}
        >
          Selecionar modelos <i className="icon icon-arrow-d" />
        </button>

        {brandsSideBarOpened && (
          <OptionsSidebar
            handleButtonCloseClick={this.handleToggleSidebar(
              'brandsSideBarOpened',
            )}
            title="Marcas"
            options={brandsOptions}
            optionWithImage
            activeItems={activeBrands}
            handleUpdateField={this.handleUpdateField('brands')}
          />
        )}

        {modelsSideBarOpened && (
          <OptionsSidebar
            handleButtonCloseClick={this.handleToggleSidebar(
              'modelsSideBarOpened',
            )}
            title="Modelos"
            options={this.filterModelsOptions()}
            activeItems={activeModels}
            handleUpdateField={this.handleUpdateField('models')}
          />
        )}
      </div>
    );
  }
}

BrandAndModels.defaultProps = {
  activeBrands: [],
  activeModels: [],
  handleUpdateFilter: () => {},
};

BrandAndModels.propTypes = {
  activeBrands: PropTypes.arrayOf(),
  activeModels: PropTypes.arrayOf(),
  handleUpdateFilter: PropTypes.func,
};

export default BrandAndModels;
